import React from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from './components/ThemeProvider';
import Layout from './components/Layout';
import PageTransition from './components/PageTransition';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Docs from './pages/Docs';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import ApiPage from './pages/ApiPage';
import Referral from './pages/Referral';
import Legal from './pages/Legal';
import SourceCode from './pages/SourceCode';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route element={<Layout />}>
          <Route path="/"          element={<PageTransition><Home /></PageTransition>} />
          <Route path="/pricing"   element={<PageTransition><Pricing /></PageTransition>} />
          <Route path="/docs"      element={<PageTransition><Docs /></PageTransition>} />
          <Route path="/about"     element={<PageTransition><About /></PageTransition>} />
          <Route path="/faq"       element={<PageTransition><FAQ /></PageTransition>} />
          <Route path="/contact"   element={<PageTransition><Contact /></PageTransition>} />
          <Route path="/developers" element={<PageTransition><ApiPage /></PageTransition>} />
          <Route path="/referral"  element={<PageTransition><Referral /></PageTransition>} />
          <Route path="/legal"     element={<PageTransition><Legal /></PageTransition>} />
          <Route path="/source"    element={<PageTransition><SourceCode /></PageTransition>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider>
      <HashRouter>
        <AnimatedRoutes />
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
